import { render, staticRenderFns } from "./RescueTeam.vue?vue&type=template&id=248b2cf2"
import script from "./RescueTeam.vue?vue&type=script&lang=js"
export * from "./RescueTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports